import actionTypes from '../actionTypes';

const initialState = {
  fields: {
    type: '',
  },
  coreg: null,
  coregTemp: null,
  coregFile: null,
  status: null,
  cart: {
    standard: 0,
    simple: 0,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.COREG_RESET_ATTRIBUTE:
      return {
        ...initialState,
        cart: {
          ...state.cart,
        },
      };

    case actionTypes.COREG_ASSIGN_ATTRIBUTE:
      return {
        ...state,
        fields: { ...state.fields, [action.field]: action.attribute },
      };

    case actionTypes.COREG_TEMP_CREATE_REQUEST:
    case actionTypes.COREG_CREATE_REQUEST:
    case actionTypes.COREG_FILE_CREATE_REQUEST:
    case actionTypes.COREG_UPDATE_REQUEST:
      return { ...state, status: action.type };

    case actionTypes.COREG_TEMP_CREATE_ERROR:
      return {
        ...state,
        status: action.type,
        error: action.error,
        coregTemp: null,
      };

    case actionTypes.COREG_CREATE_ERROR:
      return {
        ...state,
        status: action.type,
        error: action.error,
        coreg: null,
      };

    case actionTypes.COREG_UPDATE_ERROR:
      return { ...state, status: action.type, error: action.error };

    case actionTypes.COREG_TEMP_CREATE_SUCCESS:
      return { ...state, status: action.type, coregTemp: action.coregTemp };

    case actionTypes.COREG_CREATE_SUCCESS:
    case actionTypes.COREG_UPDATE_SUCCESS:
      return { ...state, status: action.type, coreg: action.coreg };

    case actionTypes.COREG_FILE_CREATE_ERROR:
      return {
        ...state,
        status: action.type,
        error: action.error,
        coregFile: null,
      };

    case actionTypes.COREG_FILE_CREATE_SUCCESS:
      return { ...state, status: action.type, coregFile: action.coregFile };

    case actionTypes.COREG_CHANGE_CART:
      return { ...state, cart: action.cart };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/redux/reducers/coreg.js